import { render, staticRenderFns } from "./ScanView.vue?vue&type=template&id=37974f35&scoped=true"
import script from "./ScanView.vue?vue&type=script&lang=js"
export * from "./ScanView.vue?vue&type=script&lang=js"
import style0 from "./ScanView.vue?vue&type=style&index=0&id=37974f35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37974f35",
  null
  
)

export default component.exports